/**
 * Pin colors for a load's route legs, shared by every surface that draws one.
 *
 * One definition because the surfaces are meant to agree: an operator reads the small Leaflet route in a
 * drawer, opens the Google planner from it, and opens a driver's route beside that. Green always means
 * the pickup end and red the delivery end. Five files used to spell these two literals out inline, so a
 * palette change — a colorblind-safe scheme, say — had five places to find and could half-land without
 * anything failing.
 *
 * Named for the ROLE, not the letter. The letters differ by surface: the drawer's route labels the legs
 * A and B, while the nearby-driver map labels the driver A and pushes pickup and delivery to B and C.
 * The colors stay pinned to what the leg means.
 *
 * Note these are the same hex values as two of Google's brand colors, which appear in the logo SVGs
 * across onboarding. That is a coincidence of palette, not a shared meaning — those are not route pins
 * and must not be pointed at these constants.
 */

/** Pickup end of a route leg. */
export const ROUTE_PIN_ORIGIN_COLOR = '#34A853'

/** Delivery end of a route leg. */
export const ROUTE_PIN_DESTINATION_COLOR = '#EA4335'
